import React from 'react';
import styled from 'styled-components';

import Paper from '@mui/material/Paper';

interface Props {}

const SidebarPanel = (props: React.PropsWithChildren) => {
    return (
        <FloatingEl>
            <Paper
                sx={{
                    height: '100%',
                    overflowY: 'auto',
                    overflowX: 'hidden',
                    borderRadius: '8px',
                }}
            >
                {props.children}
            </Paper>
        </FloatingEl>
    );
};

const FloatingEl = styled.div`
    z-index: 1;
    width: 300px;
    pointer-events: all;
    background-color: transparent;
    padding: 0.5rem 0 0.5rem 0.5rem;
    grid-column: sidebar-start / sidebar-end;
    grid-row: top / bottom;
    overflow: hidden;
`;

export default SidebarPanel;
